<template>
  <v-app :dark="dark">

    <v-toolbar
      app
      color="primary"
      v-if="toolbar"
    >
      <v-toolbar-title v-text="title"></v-toolbar-title>
    </v-toolbar>
    <v-content>
      <router-view :dark="dark"/>
    </v-content>
  </v-app>
</template>

<script>

import { mapActions } from 'vuex';
import Navigation from './ui/components/Navigation.vue';


export default {


  name: 'App',

  components: {
    Navigation,
  },

  data () {
    return {
      title: 'ELEMENT Air',
      dark: false,
      isLoading: false,
    }
  },
  created() {
    this.$root.$on("toggleTheme", () => this.dark = !this.dark)
      if (this.$route.query.auth_token) {
        this.setParams(this.$route.query);
      }
  },
  computed: {
    toolbar() {
      return false
    }
  },

  watch: {
    $route(to) {
      if (this.$route.query.auth_token) {
        this.setParams(to.query);
      }
    },
  },

  methods: {
    ...mapActions('app', ['setParams']),
  },
};
</script>



// WEBPACK FOOTER //
// src/App.vue